(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('RoundDialogController', RoundDialogController);

    RoundDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Round', 'Product', 'Country', 'Model'];

    function RoundDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Round, Product, Country, Model) {
        var vm = this;

        vm.round = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.products = Product.query();
        vm.countries = Country.query();
        vm.models = Model.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.round.id !== null) {
                Round.update(vm.round, onSaveSuccess, onSaveError);
            } else {
                Round.save(vm.round, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:roundUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;
        vm.datePickerOpenStatus.lastHist = false;
        vm.datePickerOpenStatus.lastFore = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
